export default "__VITE_ASSET__9qjjnfWV__"